import { Subject, Observable } from 'rxjs';
import { AnyAction } from 'redux';
import { boundMethod } from 'autobind-decorator';

interface window {
  dataLayer?: any[]
}

// @ts-ignore:next-line
const win: window = window;

export interface ActionEvent {
  type: string
  payload?: any
  injectPayload?: boolean
}

export class ProductAnalytics {
  private readonly stream = new Subject<ActionEvent>();

  @boundMethod
  createReduxMiddleware() {
    return () => (
      next: Function,
    ) => (
      action: AnyAction,
    ) => {
      next(action);
      this.stream.next(action);
    };
  }

  getDataLayer() {
    return win.dataLayer || [];
  }

  push(event: ActionEvent) {
    this.stream.next(event);
  }

  setUserContext(email: string) {
    this.getDataLayer().push({
      email,
    });
  }

  pushToDataLayer(data: {[key: string]: string}) {
    this.getDataLayer().push(data);
  }

  getStream(): Observable<ActionEvent> {
    return this.stream.asObservable();
  }
}
